import React, { Component } from 'react'
import { connect } from 'react-redux'

import RaisedButton from 'material-ui/RaisedButton'
import Http from 'components/drivers/Http'

import financeActions from 'actions/financeActions'

import { getReport, currentTemplate } from 'selectors/reports'

let select = state => ({
	report: getReport(state)
  , template: currentTemplate(state)
})

export class Report1099 extends Component{
	render(){
		let { props } = this
		return(
			<div style={{textAlign: 'center'}}>
				{!props.template &&
					<Http
						method="GET"
						url='/landlord/static/pdf/1099.pdf'
						onSuccess={(resp) => props.TEMPLATE_GOT({id: '1099', template: resp})}
						onError={(resp) => console.log(resp)}
						post={true}
					/>
				}
				{props.report &&
					<RaisedButton
						label="View 1099 report"
						onTouchTap={() => {
							let blob = new Blob([props.report], {type: "application/pdf"})
							let href = window.URL.createObjectURL(blob);
							window.open(href, '_blank').focus()
						}}
						style={{
							margin: "50px 0"
						}}
					/>
				}
			</div>
		)
	}
}

export default connect(select, financeActions)(Report1099)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/Report/Report1099.js